import Vue from 'vue';

export const CurrencyFilter = Vue.filter('currency', (value: string) => {
	if (value !== undefined && value !== null) {
		return parseFloat(value).toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
});
